import BannerA from '../components/BannerA';
import FooterTcA from '../components/FooterTcA';
import ListA1 from '../components/ListA1';
import ListA2 from '../components/ListA2';
import ListA3 from '../components/ListA3';
import SectionA1 from '../components/SectionA1';
import SectionA2 from '../components/SectionA2';
import SectionA3 from '../components/SectionA3';
import SectionA4 from '../components/SectionA4';
import SectionA5 from '../components/SectionA5';
import SectionA6 from '../components/SectionA6';

export default function StatusItem() {
    return (
        <>
            <BannerA />
            <ListA1 />
            <SectionA1 />
            <SectionA2 />
            <SectionA3 />
            <SectionA4 />
            <SectionA5 />
            {/* <ListA2 /> */}
            <ListA3 />
            <SectionA6 />
            {/* <FooterTcA /> */}
        </>
    );
}
